import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';
import { ACCOUNT_TYPE } from '@entities/account/IAccount';

export const fetch = async (): Promise<ISelectOption[]> => {
  return [
    { value: ACCOUNT_TYPE.MINING, label: 'Майнинг аккаунт' },
    { value: ACCOUNT_TYPE.REFERRAL, label: 'Реферальный аккаунт' },
    { value: ACCOUNT_TYPE.AGENT, label: 'Агентский аккаунт' },
  ];
};

export const useAccountTypeOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
